import { useState } from "react";
import { Link } from "react-router-dom";
import { CloudLightning, ArrowRight, X } from "lucide-react";
import { useSiteSettings } from "@/hooks/useSiteSettings";

// Automatic June–November band featuring the hurricane-prep guide.
// Hidden when manual Storm Season Mode is active (StormBanner takes over).
export default function SeasonalGuideBanner() {
    const { settings } = useSiteSettings();
    const [dismissed, setDismissed] = useState(
        () => sessionStorage.getItem("a1SeasonalGuideDismissed") === "1"
    );

    const month = new Date().getMonth(); // June=5 … November=10
    const inSeason = month >= 5 && month <= 10;
    const stormModeActive = !!settings?.storm_season_mode?.is_active;

    if (!inSeason || stormModeActive || dismissed) return null;

    const dismiss = () => {
        sessionStorage.setItem("a1SeasonalGuideDismissed", "1");
        setDismissed(true);
    };

    return (
        <div
            role="region"
            aria-label="Hurricane season guide"
            data-testid="seasonal-guide-banner"
            style={{
                background: "linear-gradient(90deg, #0d1a33 0%, #12234a 100%)",
                borderBottom: "1px solid var(--color-line)",
            }}
        >
            <div className="a1-container py-2.5 flex items-center gap-3">
                <CloudLightning size={18} className="shrink-0" style={{ color: "var(--color-warning, #fcd64b)" }} />
                <p className="text-sm m-0 flex-1 leading-snug" style={{ color: "var(--color-text)" }}>
                    <span className="font-bold" style={{ color: "var(--color-warning, #fcd64b)" }}>
                        Hurricane season runs June–November.
                    </span>{" "}
                    <span className="hidden sm:inline" style={{ color: "var(--color-text-muted)" }}>
                        Is your pool cage ready?
                    </span>{" "}
                    <Link
                        to="/blog/preparing-your-lanai-and-pool-cage-for-hurricane-season-naples"
                        className="font-bold underline underline-offset-2 hover:text-[var(--color-accent)] inline-flex items-center gap-1"
                        style={{ color: "var(--color-accent)" }}
                        data-testid="seasonal-guide-banner-link"
                    >
                        Read our prep guide <ArrowRight size={13} />
                    </Link>
                </p>
                <button
                    type="button"
                    onClick={dismiss}
                    aria-label="Dismiss hurricane season banner"
                    className="shrink-0 p-1 rounded hover:opacity-70 transition-opacity"
                    style={{ color: "var(--color-text-muted)", background: "transparent", border: "none", cursor: "pointer" }}
                    data-testid="seasonal-guide-banner-dismiss"
                >
                    <X size={16} />
                </button>
            </div>
        </div>
    );
}
